"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function MetaformSectionFromJSON(json) {
    return MetaformSectionFromJSONTyped(json, false);
}
exports.MetaformSectionFromJSON = MetaformSectionFromJSON;
function MetaformSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': !runtime_1.exists(json, 'title') ? undefined : json['title'],
        'visibleIf': !runtime_1.exists(json, 'visible-if') ? undefined : _1.FieldRuleFromJSON(json['visible-if']),
        'fields': !runtime_1.exists(json, 'fields') ? undefined : (json['fields'].map(_1.MetaformFieldFromJSON)),
    };
}
exports.MetaformSectionFromJSONTyped = MetaformSectionFromJSONTyped;
function MetaformSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'visible-if': _1.FieldRuleToJSON(value.visibleIf),
        'fields': value.fields === undefined ? undefined : (value.fields.map(_1.MetaformFieldToJSON)),
    };
}
exports.MetaformSectionToJSON = MetaformSectionToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1TZWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2dlbmVyYXRlZC9jbGllbnQvbW9kZWxzL01ldGFmb3JtU2VjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQjs7Ozs7Ozs7OztHQVVHOztBQUVILHdDQUErQztBQUMvQyx5QkFTWTtBQTRCWixTQUFnQix1QkFBdUIsQ0FBQyxJQUFTO0lBQzdDLE9BQU8sNEJBQTRCLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ3JELENBQUM7QUFGRCwwREFFQztBQUVELFNBQWdCLDRCQUE0QixDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDaEYsSUFBSSxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsRUFBRTtRQUN6QyxPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILE9BQU8sRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUM7UUFDM0QsV0FBVyxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsb0JBQWlCLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDO1FBQzVGLFFBQVEsRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUUsSUFBSSxDQUFDLFFBQVEsQ0FBZ0IsQ0FBQyxHQUFHLENBQUMsd0JBQXFCLENBQUMsQ0FBQztLQUM5RyxDQUFDO0FBQ04sQ0FBQztBQVZELG9FQVVDO0FBRUQsU0FBZ0IscUJBQXFCLENBQUMsS0FBOEI7SUFDaEUsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3JCLE9BQU8sU0FBUyxDQUFDO0tBQ3BCO0lBQ0QsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ2hCLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsT0FBTyxFQUFFLEtBQUssQ0FBQyxLQUFLO1FBQ3BCLFlBQVksRUFBRSxrQkFBZSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUM7UUFDOUMsUUFBUSxFQUFFLEtBQUssQ0FBQyxNQUFNLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUUsS0FBSyxDQUFDLE1BQXFCLENBQUMsR0FBRyxDQUFDLHNCQUFtQixDQUFDLENBQUM7S0FDN0csQ0FBQztBQUNOLENBQUM7QUFiRCxzREFhQyJ9